import { render } from "./WhoAreWe.vue?vue&type=template&id=53f13c4c&scoped=true"
import script from "./WhoAreWe.vue?vue&type=script&lang=js"
export * from "./WhoAreWe.vue?vue&type=script&lang=js"

import "./WhoAreWe.vue?vue&type=style&index=0&id=53f13c4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f13c4c"]])

export default __exports__